<template>
  <ManageCardholders />
</template>
<script>
// @ is an alias to /src
import ManageCardholders from "@/components/manageCardholders";

export default {
  name: "CardHolders",
  components: {
    ManageCardholders,
  },
};
</script>
